<section class="message-dialog">
  <!-- dialog header -->
  <div class="message-dialog__header">
    <!-- close button -->
    <button (click)="close()">
      <i class="iconsax message-dialog__close-icon" icon-name="x"></i>
    </button>
  </div>
  <div class="message-dialog__content">
    <!-- success icon -->
    <img
      class="message-dialog__image"
      [ngSrc]="
        dialogData.messageType === 'SUCCESS'
          ? 'assets/icons/green-tick-icon.png'
          : 'assets/icons/cross_red_circle.png'
      "
      width="60"
      height="60" />
    <!-- dialog title -->
    <h4 class="message-dialog__title">{{ dialogData.title | translate }}</h4>
    @if (dialogData.code) {
      <!-- dialog message -->
      <p class="message-dialog__message">
        {{ dialogData.message | translate }}
      </p>
      <!-- copy code button -->
      <pwj-button
        class="message-dialog__tracking-code"
        [icon]="codeCopiedSuccessfully ? 'tick-circle' : 'copy'"
        iconClasses="-mt-3"
        [iconReversePosition]="true"
        variant="secondary"
        (click)="onCopyOrderCode(dialogData.code)"
        >{{ dialogData.code }}</pwj-button
      >
    }
  </div>
  <!-- close button -->
  <div class="message-dialog__close-button">
    <pwj-button
      icon="chevron-right"
      [rotateIconInRtl]="true"
      [iconReversePosition]="true"
      variant="normal"
      color="success"
      (click)="close()"
      >{{ dialogData.closeButtonText | translate }}</pwj-button
    >
  </div>
</section>
